import styled from 'styled-components';
import Grow from '@mui/material/Grow';
import { getEmergencyTriageHeading } from '../utils';
import { Paragraph } from './Layout/Embedded';

export const ColorCode = styled.div<{ level: number | null }>`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border-radius: 100%;
  background-color: ${({ theme, level }) => {
    switch (level) {
      case 7:
        return theme.palette.status.error;
      case 6:
        return theme.palette.orange[30];
      default:
        return theme.palette.status.success;
    }
  }};
`;

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const TriageHeading = ({
  triage,
}: {
  triage: {
    level: number | null;
    description: string;
  };
}) => {
  return (
    <Container>
      <Grow in>
        <ColorCode level={triage.level} />
      </Grow>
      <Paragraph>
        <strong>{getEmergencyTriageHeading(triage)}</strong>
      </Paragraph>
    </Container>
  );
};

export default TriageHeading;
